import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { history } from "ftl-core";
import { DialogContainer, ErrorContainer, FTLErrorBoundary, SnackbarContainer } from "ftl-uikit";
const FTLMainLayoutErrorBoundaryComponent = ({ children }) => {
    return _jsx(FTLErrorBoundary, Object.assign({ location: history.location, fullScreen: true }, { children: _jsxs(ErrorContainer, Object.assign({ fullScreen: true }, { children: [children, _jsx(SnackbarContainer, {}, void 0), _jsx(DialogContainer, {}, void 0)] }), void 0) }), void 0);
};
export default FTLMainLayoutErrorBoundaryComponent;
//# sourceMappingURL=FTLMainLayoutErrorBoundaryComponent.js.map